import _ from 'lodash';
import { Customer, Data } from './model';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';
import { AppKeys, newMsg } from '../../core/localization';
import { GroupNames, Groups } from '../../models';

export const msgTitle = newMsg(GroupNames[Groups.CUSTOMERS]);
export const msgCustomerName = newMsg(AppKeys.Groups_Col_CustomerName);
export const msgNumDevices = newMsg(AppKeys.Groups_Col_NumDevices);
export const keyTotalCustomers = AppKeys.Num_Customer;
export const msgSearchError = newMsg(AppKeys.Customers_Search_Error);

export const getPK = (customer: Customer): string => customer.owner;

export const getLoadedCustomers = DTHelper.concatPageItems;

export const getSelectedCustomers = (
  loadedcustomers: Customer[],
  selectedKeys: string[]
) => loadedcustomers.filter((d) => selectedKeys.includes(getPK(d)));

export const getNumDevicesFromCustomers = (
  selectedKeys: string[],
  data: Data
) => {
  const customers = getSelectedCustomers(
    getLoadedCustomers(data.pages),
    selectedKeys
  );
  return _.sum(customers.map((o) => o.numDevices));
};

export const getTotalsFromSelectedKeys = (
  selectedKeys: string[],
  data: Data
) => {
  const customers = getSelectedCustomers(
    getLoadedCustomers(data.pages),
    selectedKeys
  );
  return customers
    .map((o) => o.totalsByType)
    .reduce(
      (prev, t) => {
        prev.totalConcentrators += t.totalConcentrators;
        prev.totalGateways += t.totalGateways;
        prev.totalMeters += t.totalMeters;
        prev.totalRepeaters += t.totalRepeaters;
        prev.totalValves += t.totalValves;
        return prev;
      },
      { ...Devices.TotalsByTypeDefault }
    );
};
